import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCardTitle,
  CCol,
  CForm,
  CFormInput,
  CInputGroup,
  CRow,
} from '@coreui/react'
import React, { useEffect, useState } from 'react'
import { wtApiCall } from '../../helpers/commons/ApiWrapper'
import {
  lzNotifyErrorMessageFromResult,
  lzNotifySuccessMessage,
} from '../../helpers/commons/notifications'
import Loading from '../../helpers/commons/loader'
import WidgetDepartmentSelector from '../../widgets/Selectors/WidgetDepartmentSelector'
import WidgetDesignationSelector from '../../widgets/Selectors/WidgetDesignationSelector'
import WidgetSelector from '../../widgets/Selectors/WidgetSelector'
// import WidgetProjectSelector from 'src/widgets/Selectors/WidgetProjectSelector'

import {
  CurrentlyUnemployedOptions,
  GradeOptions,
  PreviousEmployerContactOptions,
  bloodgroupOptions,
  educationstatusOptions,
  genderOptions,
  maritalstatusOptions,
  priorexperienceOptions,
  religionstatusOptions,
} from '../../helpers/commons/dropdownOptions'
import PhoneInput from '../../widgets/InputFields/PhoneInput'
import BaseListing from 'src/BaseListings'
import CnicInput from '../../widgets/InputFields/CnicInput'
import ErrorMessage from 'src/widgets/ErrorComponent/ErrorMessage'
import WidgetDatePicker from 'src/widgets/DatePickers/WidgetDatePicker'
import '../../../node_modules/font-awesome/css/font-awesome.min.css'
import ImgCrop from 'antd-img-crop'
import { Upload } from 'antd'
import WidgetEmployeeSelector from 'src/widgets/Selectors/WidgetEmployeeSelector'
import WidgetBranchSelector from 'src/widgets/Selectors/WidgetBranchSelector'
export default function Form(props) {
  const { projects, reloadProjects } = props
  const Base = new BaseListing()
  const [isDisabled, setIsDisabled] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [Employees, setEmployees] = useState([])
  const [ReportingToId, setReportingToId] = useState(0)
  const [ReportingToName, setReportingToName] = useState('')
  const [departments, setDepartments] = useState([])
  const [branches, setBranches] = useState([])
  const [ParentBranchId, setParentBranchId] = useState(0)
  const [ParentBranchName, setParentBranchName] = useState('')
  const [department_id, setDepartmentId] = useState(0)
  const [branch_id, setBranchId] = useState(0)
  // const [project_name, setProjectName] = useState('')
  // const [project_id, setProjectId] = useState(null)
  const [department_name, setDepartmentName] = useState('')
  const [designations, setDesignations] = useState(props.designations)
  const [designation_id, setDesignationId] = useState(0)
  const [designation_name, setDesignationName] = useState('')
  const [first_name, setFirstName] = useState('')
  const [last_name, setLastName] = useState('')
  const [gender, setGender] = useState('')
  const [date_of_birth, setDateOfBirth] = useState('')
  const [grade, setGrade] = useState('')
  const [domicile, setDomicile] = useState('')
  const [personal_file_no, setPersonalFileNo] = useState('')
  const [date_of_joining, setDateOfJoining] = useState('')
  const [expiry_date, setExpiryDate] = useState('')
  const [mobile_no, setMobileNo] = useState('')
  const [phone_no, setPhoneNo] = useState('')
  const [permanent_address, setParmanentAddress] = useState('')
  const [resident_address, setResidentAddress] = useState('')
  const [cnic, setCnic] = useState('')
  const [cnic_issue_date, setCnicIssueDate] = useState('')
  const [cnic_expiry_date, setCnicExpiryDate] = useState('')
  const [personal_email, setPersonalEmail] = useState('')
  const [official_email, setOfficialEmail] = useState('')
  const [marital_status, setmaritalStatus] = useState('')
  const [blood_group, setBloodGroup] = useState('')
  const [religion_status, setReligionStatus] = useState('Islam')
  const [education_status, setEducationStatus] = useState('')
  const [work_experience, setWorkExperience] = useState('')
  const [currently_unemployed, setCurrentlyUnemployed] = useState('')
  const [previous_employer_contact, setPreviousEmployerContact] = useState('')
  const [driving_license, setDrivingLicense] = useState('')
  const [driving_license_issue_date, setDrivingLicenseIssueDate] = useState('')
  const [driving_license_expiry_date, setDrivingLicenseExpiryDate] = useState('')
  const [profile_picture, setProfilePicture] = useState('')
  const [emergency_contact_name, setEmergencyContactName] = useState('')
  const [relationship_with_employee, setRelationshipWithEmployee] = useState('')
  const [emergency_phone_no, setEmergencyPhoneNumber] = useState('')
  const [emergency_resident_address, setEmergencyResidentAddress] = useState('')
  const [emergency_email, setEmergencyEmail] = useState('')
  const [errors, setErrors] = useState([])
  const [attachments, setAttachments] = useState([])
  const [passport_no, setPassportNo] = useState('')
  const [passport_issue_date, setPassportIssueDate] = useState('')
  const [passport_expiry_date, setPassportExpiryDate] = useState('')
  const [ranks, setRanks] = useState([])
  const [is_retired_army_person, setIsRetiredArmyPerson] = useState(0)
  const [retired_from, setRetiredFrom] = useState('')
  const [rank_id, setRankId] = useState(0)
  const [rank_name, setRankName] = useState('')
  const [army_course, setArmyCourse] = useState('')
  const [army_corps, setArmyCorps] = useState('')
  const [army_unit, setArmyUnit] = useState('')
  const [pa_pss_no, setPaPssNo] = useState('')
  const [date_of_commissioning, setDateOfCommissioning] = useState('')
  const [date_of_retirement, setDateOfRetirement] = useState('')

  const save = () => {
    setIsDisabled(true)
    const formdata = new FormData()
    formdata.append('department_id', department_id)
    formdata.append('parent_branch_id', ParentBranchId)
    formdata.append('designation_id', designation_id)
    // formdata.append('project_id', project_id)

    // formdata.append('reporting_to_id', ReportingToId)
    formdata.append('first_name', first_name)
    formdata.append('last_name', last_name)
    formdata.append('date_of_birth', date_of_birth)
    formdata.append('grade', grade)
    formdata.append('domicile', domicile)
    formdata.append('personal_file_no', personal_file_no)
    formdata.append('date_of_joining', date_of_joining)
    // formdata.append('expiry_date', expiry_date)
    formdata.append('mobile_no', mobile_no)
    formdata.append('phone_no', phone_no)
    formdata.append('gender', gender)
    formdata.append('permanent_address', permanent_address)
    formdata.append('resident_address', resident_address)
    formdata.append('cnic', cnic)
    formdata.append('personal_email', personal_email)
    formdata.append('official_email', official_email)
    formdata.append('cnic_issue_date', cnic_issue_date)
    formdata.append('cnic_expiry_date', cnic_expiry_date)
    formdata.append('marital_status', marital_status)
    formdata.append('blood_group', blood_group)
    formdata.append('work_experience', work_experience)
    formdata.append('currently_unemployed', currently_unemployed)
    formdata.append('previous_employer_contact', previous_employer_contact)
    formdata.append('driving_license', driving_license)
    formdata.append('driving_license_issue_date', driving_license_issue_date)
    formdata.append('driving_license_expiry_date', driving_license_expiry_date)
    // formdata.append('political_party', political_party)
    // formdata.append('criminal_charge', criminal_charge)
    formdata.append('education_status', education_status)
    formdata.append('emergency_contact_name', emergency_contact_name)
    formdata.append('relationship_with_employee', relationship_with_employee)
    formdata.append('emergency_phone_no', emergency_phone_no)
    formdata.append('emergency_resident_address', emergency_resident_address)
    formdata.append('emergency_email', emergency_email)
    formdata.append('religion_status', religion_status)
    formdata.append('passport_no', passport_no)
    formdata.append('passport_issue_date', passport_issue_date)
    formdata.append('passport_expiry_date', passport_expiry_date)
    formdata.append('branch_id', branch_id)
    formdata.append('is_retired_army_person', is_retired_army_person)
    formdata.append('retired_from', is_retired_army_person === 1 ? retired_from : '')
    formdata.append('rank_id', is_retired_army_person === 1 ? rank_id : '')
    formdata.append('army_course', is_retired_army_person === 1 ? army_course : '')
    formdata.append('army_corps', is_retired_army_person === 1 ? army_corps : '')
    formdata.append('army_unit', is_retired_army_person === 1 ? army_unit : '')
    formdata.append('pa_pss_no', is_retired_army_person === 1 ? pa_pss_no : '')
    formdata.append('date_of_commissioning', is_retired_army_person === 1 ? date_of_commissioning : '')
    formdata.append('date_of_retirement', is_retired_army_person === 1 ? date_of_retirement : '')

    attachments.map((item) => formdata.append('attachments[]', item.originFileObj))
    wtApiCall(
      'employees' + (props.editId > 0 ? '/' + props.editId : ''),
      formdata,
      'post',
      (response) => {
        setIsDisabled(false)
        lzNotifySuccessMessage(response.data)
        props.onClose()
      },
      (error) => {
        setIsDisabled(false)
        lzNotifyErrorMessageFromResult(error.message)
        if (error.hasOwnProperty('errors')) {
          setErrors(error.errors)
        }
      },
    )
  }

  const getData = () => {
    if (props.editId !== 0) {
      wtApiCall(
        'employees/' + props.editId,
        {},
        'get',
        (response) => {
          setReportingToId(response.data.reporting_to_id)
          setReportingToName(response.data.reporting_to_name)
          setDepartmentId(response.data.department_id)
          setParentBranchId(response.data.parent_branch_id)
          setDepartmentName(response.data.department_name)
          setDesignationId(response.data.designation_id)
          setDesignationName(response.data.designation_name)
          setFirstName(response.data.first_name)
          setLastName(response.data.last_name)
          setGender(response.data.gender)
          setDateOfBirth(response.data.date_of_birth)
          setGrade(response.data.grade)
          setDomicile(response.data.domicile)
          setPersonalFileNo(response.data.personal_file_no)
          setDateOfJoining(response.data.date_of_joining)
          setExpiryDate(response.data.expiry_date)
          setMobileNo(response.data.mobile_no)
          setPhoneNo(response.data.phone_no)
          setParmanentAddress(response.data.permanent_address)
          setResidentAddress(response.data.resident_address)
          setCnic(response.data.cnic)
          // setProjectId(response.data.project_id)
          // setProjectName(response.data.project ? response.data.project.name : '')
          setCnicIssueDate(response.data.cnic_issue_date)
          setCnicExpiryDate(response.data.cnic_expiry_date)
          setPersonalEmail(response.data.personal_email)
          setOfficialEmail(response.data.official_email)
          setmaritalStatus(response.data.marital_status)
          setBloodGroup(response.data.blood_group)
          setReligionStatus(response.data.religion_status)
          setProfilePicture(response.data.profile_picture)
          setWorkExperience(response.data.work_experience)
          setCurrentlyUnemployed(response.data.currently_unemployed)
          setPreviousEmployerContact(response.data.previous_employer_contact)
          setDrivingLicense(response.data.driving_license)
          setDrivingLicenseIssueDate(response.data.driving_license_issue_date)
          setDrivingLicenseExpiryDate(response.data.driving_license_expiry_date)
          setPassportNo(response.data.passport_no)
          setPassportIssueDate(response.data.passport_issue_date)
          setPassportExpiryDate(response.data.passport_expiry_date)
          setIsRetiredArmyPerson(response.data.is_retired_army_person || 0)
          setRetiredFrom(response.data.retired_from || '')
          setRankId(response.data.rank_id || 0)
          setRankName(response.data.rank_name || '')
          setArmyCourse(response.data.army_course || '')
          setArmyCorps(response.data.army_corps || '')
          setArmyUnit(response.data.army_unit || '')
          setPaPssNo(response.data.pa_pss_no || '')
          setDateOfCommissioning(response.data.date_of_commissioning || '')
          setDateOfRetirement(response.data.date_of_retirement || '')
          // setPoliticalParty(response.data.political_party)
          // setCriminalCharge(response.data.criminal_charge)
          setEducationStatus(response.data.education_status)
          setEmergencyContactName(response.data.emergency_contact_name)
          setRelationshipWithEmployee(response.data.relationship_with_employee)
          setEmergencyPhoneNumber(response.data.emergency_phone_no)
          setEmergencyResidentAddress(response.data.emergency_resident_address)
          setEmergencyEmail(response.data.emergency_email)
          setAttachments([{ url: response.data.profile_picture }])
          setBranchId(response.data.branch_id)

          setIsLoading(false)
        },
        (error) => {
          // console.log(error.message)
          lzNotifyErrorMessageFromResult(error.message)
        },
      )
    } else {
      setIsLoading(false)
    }
  }

  const changeValues = (key, val) => {
    if (key === 'department_id') {
      setDepartmentId(val.value)
      setDepartmentName(val.label)
    }
    if (key === 'parent_branch_id') {
      setParentBranchId(val.value)
      setParentBranchName(val.label)
    }
    if (key === 'designation_id') {
      setDesignationId(val.value)
      setDesignationName(val.label)
    }
    if (key === 'reporting_to_id') {
      setReportingToId(val.value)
      setReportingToName(val.label)
    }
    if (key === 'rank_id') {
      setRankId(val.value)
      setRankName(val.label)
    }
    // if (key === 'project_id') {
    //   setProjectId(val)
    //   if (val === null) {
    //     setProjectName('')
    //   }
    // }
  }

  const onChangePicture = (ev) => {
    let { fileList } = ev
    fileList.forEach((element) => {
      element.originFileObj.file_preview_path = URL.createObjectURL(element.originFileObj)
    })
    setAttachments(fileList)
  }
  const onPreview = async (file) => {
    let src = file.url
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader()
        reader.readAsDataURL(file.originFileObj)
        reader.onload = () => resolve(reader.result)
      })
    }
    const image = new Image()
    image.src = src
    const imgWindow = window.open(src)
    imgWindow?.document.write(image.outerHTML)
  }

  useEffect(() => {
    Base.dropdownData(
      'departments,designations,employees,branches,ranks',
      {},
      [setDepartments, setDesignations, setEmployees, setBranches, setRanks],
      1,
    )

    getData()
  }, [])
  if (isLoading) {
    return Loading
  }
  return (
    <>
      <CRow>
        <CCol md={12}>
          <CCard className="card-dark">
            <CCardHeader style={{ backgroundColor: '#3c4b64' }}>
              <CCardTitle className="text-white">Create New Employee</CCardTitle>
            </CCardHeader>
            <CCardBody>
              <CButton className="btn-sm" color="warning" onClick={() => props.onClose()}>
                <i className="fa fa-arrow-left"></i> Back
              </CButton>
              <br />
              <br />
              <CRow>
                <CCol md={3}>
                  <ImgCrop rotationSlider>
                    <Upload
                      beforeUpload={() => false}
                      listType="picture-circle"
                      fileList={attachments}
                      onChange={(ev) => onChangePicture(ev)}
                      onPreview={onPreview}
                      disabled={props.editId ? props.editId : false}
                    >
                      {attachments.length <= 0 && '+ Upload'}
                    </Upload>
                  </ImgCrop>
                </CCol>
                <CCol md={3}>
                  <label>
                    <h4 style={{ color: '#046ecc' }}>
                      {first_name ? first_name : 'Employee Name'}&nbsp;{last_name ? last_name : ''}
                    </h4>
                  </label>
                  <br />
                  <label>
                    <i class="fa fa-venus-mars"></i>
                    &nbsp;{gender ? gender : 'Gender'}
                  </label>
                  <br />
                  <label>
                    <i class="fa fa-id-card"></i>
                    &nbsp;{cnic ? cnic : 'CNIC'}
                  </label>
                </CCol>
                <CCol md={3} style={{ border: 'right' }}>
                  <label>
                    <i class="fa fa-building"></i>
                    &nbsp;{department_name ? department_name : 'Department'}
                  </label>
                  <br />
                  <label>
                    <i class="fa fa-briefcase"></i>
                    &nbsp;{designation_name ? designation_name : 'Designation'}
                  </label>
                </CCol>
                <CCol md={3}>
                  <br />
                  <label>
                    <i className="fa fa-phone"></i>
                    &nbsp;{mobile_no ? mobile_no : 'Mobile no.'}
                  </label>
                  <br />
                  <label>
                    <i class="fa fa-envelope"></i>
                    &nbsp;{personal_email ? personal_email : 'Email'}
                  </label>
                  <br />
                  <label>
                    <i class="fa fa-calendar"></i>
                    &nbsp;{date_of_joining ? date_of_joining : 'Date Of Joining'}
                  </label>
                </CCol>
              </CRow>
              <hr />
              <br />
              <CForm>
                <CRow>
                  <h4>Basic Details:</h4>
                  <CCol md={4}>
                    <div className="form-group" style={{ marginBottom: '20px' }}>
                      <label>First Name</label>
                      <CFormInput
                        placeholder="Enter first Name"
                        value={first_name}
                        onChange={(ev) => setFirstName(ev.target.value)}
                        className={errors.first_name ? 'is-invalid' : ''}
                      />
                      {errors.first_name && <ErrorMessage messages={errors.first_name} />}
                    </div>
                  </CCol>
                  <CCol md={4}>
                    <div className="form-group">
                      <label>Last Name</label>
                      <CFormInput
                        placeholder="Enter Last Name"
                        value={last_name}
                        onChange={(ev) => setLastName(ev.target.value)}
                        className={errors.last_name ? 'is-invalid' : ''}
                      />
                      {errors.last_name && <ErrorMessage messages={errors.last_name} />}
                    </div>
                  </CCol>
                  <CCol md={4}>
                    <div className="form-group">
                      <label>Gender</label>
                      <WidgetSelector
                        options={genderOptions}
                        placeHolder={'Please Select'}
                        selectedValue={gender}
                        onChange={(values) => setGender(values.value)}
                      />
                      {errors.gender && <ErrorMessage messages={errors.gender} />}
                    </div>
                  </CCol>
                  <CCol md={4}>
                    <div className="form-group" style={{ marginBottom: '20px' }}>
                      <label>Date of Birth</label>
                      <WidgetDatePicker
                        value={date_of_birth}
                        setDate={setDateOfBirth}
                        placeholder="Select Date of Birth"
                        className={errors.date_of_birth ? 'is-invalid' : ''}
                      />
                      {errors.date_of_birth && <ErrorMessage messages={errors.date_of_birth} />}
                    </div>
                  </CCol>
                  <CCol md={4}>
                    <div className="form-group">
                      <label>Grade</label>
                      <WidgetSelector
                        options={GradeOptions}
                        placeHolder={'Please Select'}
                        selectedValue={grade}
                        onChange={(values) => setGrade(values.value)}
                      />
                      {errors.grade && <ErrorMessage messages={errors.grade} />}
                    </div>
                  </CCol>
                  <CCol md={4}>
                    <div className="form-group">
                      <label>Domicile</label>
                      <CFormInput
                        placeholder="Enter Domicile"
                        value={domicile}
                        onChange={(ev) => setDomicile(ev.target.value)}
                        className={errors.domicile ? 'is-invalid' : ''}
                      />
                      {errors.domicile && <ErrorMessage messages={errors.domicile} />}
                    </div>
                  </CCol>
                  <CCol md={4}>
                    <div className="form-group">
                      <label>Personal File No.</label>
                      <CFormInput
                        placeholder="Enter Personal File No."
                        value={personal_file_no}
                        onChange={(ev) => setPersonalFileNo(ev.target.value)}
                        className={errors.personal_file_no ? 'is-invalid' : ''}
                      />
                      {errors.personal_file_no && (
                        <ErrorMessage messages={errors.personal_file_no} />
                      )}
                    </div>
                  </CCol>
                  <CCol md={4}>
                    <div className="form-group">
                      <label>CNIC</label>
                      <CnicInput
                        placeholder="Enter CNIC"
                        value={cnic}
                        onChange={(ev) => setCnic(ev.target.value)}
                        className={errors.cnic ? 'is-invalid' : ''}
                      />
                      {errors.cnic && <ErrorMessage messages={errors.cnic} />}
                    </div>
                  </CCol>
                  <CCol md={4}>
                    <div className="form-group">
                      <label>CNIC Issue Date</label>
                      <WidgetDatePicker
                        value={cnic_issue_date}
                        setDate={setCnicIssueDate}
                        placeholder="Select Cnic Issue Date"
                        className={errors.cnic_issue_date ? 'is-invalid' : ''}
                      />
                      {errors.cnic_issue_date && <ErrorMessage messages={errors.cnic_issue_date} />}
                    </div>
                  </CCol>
                  <CCol md={4}>
                    <div className="form-group">
                      <label>CNIC Expiry Date</label>
                      <WidgetDatePicker
                        value={cnic_expiry_date}
                        setDate={setCnicExpiryDate}
                        placeholder="Select Cnic Expiry Date"
                        className={errors.cnic_expiry_date ? 'is-invalid' : ''}
                      />
                      {errors.cnic_expiry_date && (
                        <ErrorMessage messages={errors.cnic_expiry_date} />
                      )}
                    </div>
                  </CCol>
                  <br />
                  <br />
                  <br />
                  <br />
                  <h4>Work Details:</h4>

                  <CCol md={4}>
                    <CInputGroup>
                      <label>Parent Branch</label>
                      <WidgetBranchSelector
                        branches={branches}
                        displayValue={ParentBranchName}
                        value={ParentBranchId}
                        placeholder="Select Branch"
                        onChange={(values) => changeValues('parent_branch_id', values)}
                        reloadDropdownData={() => Base.dropdownData('branches', {}, [setBranches], 1)}
                      />
                    </CInputGroup>
                  </CCol>

                  <CCol md={4}>
                    <CInputGroup>
                      <label>Department</label>
                      <WidgetDepartmentSelector
                        departments={departments}
                        displayValue={department_name}
                        value={department_id}
                        placeholder="Select Department"
                        onChange={(values) => changeValues('department_id', values)}
                        reloadDropdownData={() => Base.dropdownData("departments", {}, [setDepartments], 1)}
                      />
                      {errors.department_id && <ErrorMessage messages={errors.department_id} />}
                    </CInputGroup>
                  </CCol>
                  <CCol md={4}>
                    <CInputGroup>
                      <label>Designation</label>
                      <WidgetDesignationSelector
                        designations={designations}
                        displayValue={designation_name}
                        value={designation_id}
                        placeholder="Select Designation"
                        onChange={(values) => changeValues('designation_id', values)}
                        reloadDropdownData={() =>
                          Base.dropdownData('designations', {}, [setDesignations], 1)
                        }
                      />
                      {errors.designation_id && <ErrorMessage messages={errors.designation_id} />}
                    </CInputGroup>
                  </CCol>

                  {/* <CCol md={4}>
                    <CInputGroup>
                      <label>Project</label>
                      <WidgetProjectSelector
                        data={projects}
                        displayValue={project_name}
                        value={project_id}
                        // viewOnly={viewOnly}
                        onChange={(values) => changeValues('project_id', values)}
                        reloadDropdownData={() => reloadProjects()}

                      />
                      {errors.project_id && <ErrorMessage messages={errors.project_id} />}
                    </CInputGroup>
                  </CCol> */}
                  <CCol md={4}>
                    <div className="form-group">
                      <label>Date of Joining</label>
                      <WidgetDatePicker
                        value={date_of_joining}
                        setDate={setDateOfJoining}
                        placeholder="Select Date of Joining"
                        className={errors.date_of_joining ? 'is-invalid' : ''}
                      />
                      {errors.date_of_joining && <ErrorMessage messages={errors.date_of_joining} />}
                    </div>
                  </CCol>
                  {/* <CCol md={4}>
                    <div className="form-group">
                      <label>Date of Retirement</label>
                      <WidgetDatePicker
                        value={expiry_date}
                        setDate={setExpiryDate}
                        placeholder="Select Date of Retirement"
                        className={errors.expiry_date ? 'is-invalid' : ''}
                      />
                      {errors.expiry_date && <ErrorMessage messages={errors.expiry_date} />}
                    </div>
                  </CCol> */}
                  {/* <CCol md={4}>
                    <CInputGroup>
                      <label>Reporting To</label>
                      <WidgetEmployeeSelector
                        employees={Employees}
                        displayValue={ReportingToName}
                        value={ReportingToId}
                        placeholder="Select Reporting To"
                        onChange={(values) => changeValues('reporting_to_id', values)}
                        reloadDropdownData={() =>
                          Base.dropdownData('employees', {}, [setEmployees], 1)
                        }
                      />
                      {errors.reporting_to_id && <ErrorMessage messages={errors.reporting_to_id} />}
                    </CInputGroup>
                  </CCol> */}
                  <br />
                  <br />
                  <br />
                  <br />
                  <h4>Contact Details:</h4>
                  <CCol md={4}>
                    <div className="form-group" style={{ marginBottom: '20px' }}>
                      <label>Mobile no.</label>
                      <PhoneInput
                        placeholder="Enter Mobile no."
                        value={mobile_no}
                        onChange={(ev) => setMobileNo(ev.target.value)}
                        className={errors.mobile_no ? 'is-invalid' : ''}
                      />
                      {errors.mobile_no && <ErrorMessage messages={errors.mobile_no} />}
                    </div>
                  </CCol>
                  <CCol md={4}>
                    <div className="form-group">
                      <label>Phone no.</label>
                      <CFormInput
                        placeholder="Enter Phone no."
                        value={phone_no}
                        onChange={(ev) => setPhoneNo(ev.target.value)}
                        className={errors.phone_no ? 'is-invalid' : ''}
                      />
                      {errors.phone_no && <ErrorMessage messages={errors.phone_no} />}
                    </div>
                  </CCol>
                  <CCol md={4}>
                    <div className="form-group">
                      <label>Permanent Address</label>
                      <CFormInput
                        placeholder="Enter Permanent Address"
                        value={permanent_address}
                        onChange={(ev) => setParmanentAddress(ev.target.value)}
                        className={errors.permanent_address ? 'is-invalid' : ''}
                      />
                      {errors.permanent_address && (
                        <ErrorMessage messages={errors.permanent_address} />
                      )}
                    </div>
                  </CCol>
                  <CCol md={4}>
                    <div className="form-group">
                      <label>Resident Address</label>
                      <CFormInput
                        placeholder="Enter Resident Address"
                        value={resident_address}
                        onChange={(ev) => setResidentAddress(ev.target.value)}
                        className={errors.resident_address ? 'is-invalid' : ''}
                      />
                      {errors.resident_address && (
                        <ErrorMessage messages={errors.resident_address} />
                      )}
                    </div>
                  </CCol>
                  <CCol md={4}>
                    <div className="form-group">
                      <label>Personal Email</label>
                      <CFormInput
                        placeholder="Enter Personal Email"
                        type="email"
                        value={personal_email}
                        onChange={(ev) => setPersonalEmail(ev.target.value)}
                        className={errors.personal_email ? 'is-invalid' : ''}
                      />
                      {errors.personal_email && <ErrorMessage messages={errors.personal_email} />}
                    </div>
                  </CCol>
                  <CCol md={4}>
                    <div className="form-group">
                      <label>Official Email</label>
                      <CFormInput
                        placeholder="Enter Official Email"
                        type="email"
                        value={official_email}
                        onChange={(ev) => setOfficialEmail(ev.target.value)}
                        className={errors.official_email ? 'is-invalid' : ''}
                      />
                      {errors.official_email && <ErrorMessage messages={errors.official_email} />}
                    </div>
                  </CCol>
                  <br />
                  <br />
                  <br />
                  <br />
                  <h4>Emergency Details:</h4>
                  <CCol md={4}>
                    <div className="form-group" style={{ marginBottom: '20px' }}>
                      <label>Name</label>
                      <CFormInput
                        placeholder="Enter Name"
                        value={emergency_contact_name}
                        onChange={(ev) => setEmergencyContactName(ev.target.value)}
                        className={errors.emergency_contact_name ? 'is-invalid' : ''}
                      />
                      {errors.emergency_contact_name && (
                        <ErrorMessage messages={errors.emergency_contact_name} />
                      )}
                    </div>
                  </CCol>
                  <CCol md={4}>
                    <div className="form-group">
                      <label>Relationship with Employee</label>
                      <CFormInput
                        placeholder="Enter Relationship with Employee"
                        value={relationship_with_employee}
                        onChange={(ev) => setRelationshipWithEmployee(ev.target.value)}
                        className={errors.relationship_with_employee ? 'is-invalid' : ''}
                      />
                      {errors.relationship_with_employee && (
                        <ErrorMessage messages={errors.relationship_with_employee} />
                      )}
                    </div>
                  </CCol>
                  <CCol md={4}>
                    <div className="form-group">
                      <label>Phone no.</label>
                      <CFormInput
                        placeholder="Enter Phone no."
                        value={emergency_phone_no}
                        onChange={(ev) => setEmergencyPhoneNumber(ev.target.value)}
                        className={errors.emergency_phone_no ? 'is-invalid' : ''}
                      />
                      {errors.emergency_phone_no && (
                        <ErrorMessage messages={errors.emergency_phone_no} />
                      )}
                    </div>
                  </CCol>
                  <CCol md={4}>
                    <div className="form-group">
                      <label>Resident Address</label>
                      <CFormInput
                        placeholder="Enter Resident Address"
                        value={emergency_resident_address}
                        onChange={(ev) => setEmergencyResidentAddress(ev.target.value)}
                        className={errors.emergency_resident_address ? 'is-invalid' : ''}
                      />
                      {errors.emergency_resident_address && (
                        <ErrorMessage messages={errors.emergency_resident_address} />
                      )}
                    </div>
                  </CCol>
                  <CCol md={4}>
                    <div className="form-group">
                      <label>Email</label>
                      <CFormInput
                        placeholder="Enter Email"
                        type="email"
                        value={emergency_email}
                        onChange={(ev) => setEmergencyEmail(ev.target.value)}
                        className={errors.emergency_email ? 'is-invalid' : ''}
                      />
                      {errors.emergency_email && <ErrorMessage messages={errors.emergency_email} />}
                    </div>
                  </CCol>
                  <br />
                  <br />
                  <br />
                  <br />
                  <h4>Other Details:</h4>
                  <CCol md={4}>
                    <div className="form-group" style={{ marginBottom: '20px' }}>
                      <label>Marital Status</label>
                      <WidgetSelector
                        options={maritalstatusOptions}
                        placeHolder={'Please Select'}
                        selectedValue={marital_status}
                        onChange={(values) => setmaritalStatus(values.value)}
                      />
                      {errors.marital_status && <ErrorMessage messages={errors.marital_status} />}
                    </div>
                  </CCol>
                  <CCol md={4}>
                    <div className="form-group">
                      <label>Blood Group</label>
                      <WidgetSelector
                        options={bloodgroupOptions}
                        placeHolder={'Please Select'}
                        selectedValue={blood_group}
                        onChange={(values) => setBloodGroup(values.value)}
                      />
                      {errors.blood_group && <ErrorMessage messages={errors.blood_group} />}
                    </div>
                  </CCol>
                  <CCol md={4}>
                    <div className="form-group">
                      <label>Religion</label>
                      <WidgetSelector
                        options={religionstatusOptions}
                        placeHolder={'Please Select'}
                        selectedValue={religion_status}
                        onChange={(values) => setReligionStatus(values.value)}
                      />
                      {errors.religion_status && <ErrorMessage messages={errors.religion_status} />}
                    </div>
                  </CCol>
                  <CCol md={4}>
                    <div className="form-group" style={{ marginBottom: '20px' }}>
                      <label>Education Status</label>
                      <WidgetSelector
                        options={educationstatusOptions}
                        placeHolder={'Please Select'}
                        selectedValue={education_status}
                        onChange={(values) => setEducationStatus(values.value)}
                      />
                      {errors.education_status && (
                        <ErrorMessage messages={errors.education_status} />
                      )}
                    </div>
                  </CCol>
                  <CCol md={4}>
                    <div className="form-group">
                      <label>Prior Experience</label>
                      <WidgetSelector
                        options={priorexperienceOptions}
                        placeHolder={'Please Select'}
                        selectedValue={work_experience}
                        onChange={(values) => setWorkExperience(values.value)}
                      />
                      {errors.work_experience && <ErrorMessage messages={errors.work_experience} />}
                    </div>
                  </CCol>
                  <CCol md={4}>
                    <div className="form-group">
                      <label>Are you currently Unemployed?</label>
                      <WidgetSelector
                        options={CurrentlyUnemployedOptions}
                        placeHolder={'Please Select'}
                        selectedValue={currently_unemployed}
                        onChange={(values) => setCurrentlyUnemployed(values.value)}
                      />
                      {errors.currently_unemployed && (
                        <ErrorMessage messages={errors.currently_unemployed} />
                      )}
                    </div>
                  </CCol>
                  <CCol md={4}>
                    <div className="form-group" style={{ marginBottom: '20px' }}>
                      <label>May we contact your previous employer(s)?</label>
                      <WidgetSelector
                        options={PreviousEmployerContactOptions}
                        placeHolder={'Please Select'}
                        selectedValue={previous_employer_contact}
                        onChange={(values) => setPreviousEmployerContact(values.value)}
                      />
                      {errors.previous_employer_contact && (
                        <ErrorMessage messages={errors.previous_employer_contact} />
                      )}
                    </div>
                  </CCol>
                  <CCol md={4}>
                    <div className="form-group">
                      <label>Driving License</label>
                      <CFormInput
                        placeholder="Enter Driving License"
                        value={driving_license}
                        onChange={(ev) => setDrivingLicense(ev.target.value)}
                        className={errors.driving_license ? 'is-invalid' : ''}
                      />
                      {errors.driving_license && <ErrorMessage messages={errors.driving_license} />}
                    </div>
                  </CCol>
                  <CCol md={4}>
                    <div className="form-group">
                      <label>Driving License Issue Date</label>
                      <WidgetDatePicker
                        value={driving_license_issue_date}
                        setDate={setDrivingLicenseIssueDate}
                        placeholder="Select Driving License Issue Date"
                        className={errors.driving_license_issue_date ? 'is-invalid' : ''}
                      />
                      {errors.driving_license_issue_date && (
                        <ErrorMessage messages={errors.driving_license_issue_date} />
                      )}
                    </div>
                  </CCol>
                  <CCol md={4}>
                    <div className="form-group">
                      <label>Driving License Expiry Date</label>
                      <WidgetDatePicker
                        value={driving_license_expiry_date}
                        setDate={setDrivingLicenseExpiryDate}
                        placeholder="Select Driving License Expiry Date"
                        className={errors.driving_license_expiry_date ? 'is-invalid' : ''}
                      />
                      {errors.driving_license_expiry_date && (
                        <ErrorMessage messages={errors.driving_license_expiry_date} />
                      )}
                    </div>
                  </CCol>
                  <CCol md={4}>
                    <div className="form-group">
                      <label>Passport No</label>
                      <CFormInput
                        placeholder="Enter Passport No"
                        value={passport_no}
                        onChange={(ev) => setPassportNo(ev.target.value)}
                        className={errors.passport_no ? 'is-invalid' : ''}
                      />
                      {errors.passport_no && <ErrorMessage messages={errors.passport_no} />}
                    </div>
                  </CCol>
                  <CCol md={4}>
                    <div className="form-group">
                      <label>Passport Issue Date</label>
                      <WidgetDatePicker
                        value={passport_issue_date}
                        setDate={setPassportIssueDate}
                        placeholder="Select Passport Issue Date"
                        className={errors.passport_issue_date ? 'is-invalid' : ''}
                      />
                      {errors.passport_issue_date && (
                        <ErrorMessage messages={errors.passport_issue_date} />
                      )}
                    </div>
                  </CCol>
                  <CCol md={4}>
                    <div className="form-group">
                      <label>Passport Expiry Date</label>
                      <WidgetDatePicker
                        value={passport_expiry_date}
                        setDate={setPassportExpiryDate}
                        placeholder="Select Passport Expiry Date"
                        className={errors.passport_expiry_date ? 'is-invalid' : ''}
                      />
                      {errors.passport_expiry_date && (
                        <ErrorMessage messages={errors.passport_expiry_date} />
                      )}
                    </div>
                  </CCol>

                  <CCol md={4}>
                    <div className="form-group">
                      <label>Retired Army Person?</label>
                      <WidgetSelector
                        options={[{ value: 1, label: 'Yes' }, { value: 0, label: 'No' }]}
                        placeHolder="Please Select"
                        selectedValue={is_retired_army_person}
                        onChange={(values) => {
                          setIsRetiredArmyPerson(values.value)
                          if (values.value !== 1) {
                            setRetiredFrom('')
                            setRankId(0)
                            setRankName('')
                          }
                        }}
                      />
                      {errors.is_retired_army_person && <ErrorMessage messages={errors.is_retired_army_person} />}
                    </div>
                  </CCol>

                  {is_retired_army_person === 1 && (
                    <>
                      <CCol md={4}>
                        <div className="form-group">
                          <label>Retired From</label>
                          <WidgetSelector
                            options={[{ value: 'Army', label: 'Army' }, { value: 'Navy', label: 'Navy' }, { value: 'Airforce', label: 'Airforce' }]}
                            placeHolder="Select Service"
                            selectedValue={retired_from}
                            onChange={(values) => setRetiredFrom(values.value)}
                          />
                          {errors.retired_from && <ErrorMessage messages={errors.retired_from} />}
                        </div>
                      </CCol>
                      <CCol md={4}>
                        <div className="form-group">
                          <label>Rank</label>
                          <WidgetSelector
                            options={ranks}
                            placeHolder="Select Rank"
                            selectedValue={rank_id}
                            displayValue={rank_name}
                            onChange={(values) => changeValues('rank_id', values)}
                          />
                          {errors.rank_id && <ErrorMessage messages={errors.rank_id} />}
                        </div>
                      </CCol>
                      <CCol md={4}><div className="form-group"><label>Course</label><CFormInput value={army_course} onChange={(ev) => setArmyCourse(ev.target.value)} />{errors.army_course && <ErrorMessage messages={errors.army_course} />}</div></CCol>
                      <CCol md={4}><div className="form-group"><label>Corps</label><CFormInput value={army_corps} onChange={(ev) => setArmyCorps(ev.target.value)} />{errors.army_corps && <ErrorMessage messages={errors.army_corps} />}</div></CCol>
                      <CCol md={4}><div className="form-group"><label>Unit</label><CFormInput value={army_unit} onChange={(ev) => setArmyUnit(ev.target.value)} />{errors.army_unit && <ErrorMessage messages={errors.army_unit} />}</div></CCol>
                      <CCol md={4}><div className="form-group"><label>PA/PSS No.</label><CFormInput value={pa_pss_no} onChange={(ev) => setPaPssNo(ev.target.value)} />{errors.pa_pss_no && <ErrorMessage messages={errors.pa_pss_no} />}</div></CCol>
                      <CCol md={4}>
                        <div className="form-group"><label>Date of Commissioning</label><WidgetDatePicker value={date_of_commissioning} setDate={setDateOfCommissioning} placeholder="Select Date" />{errors.date_of_commissioning && <ErrorMessage messages={errors.date_of_commissioning} />}</div>
                      </CCol>
                      <CCol md={4}>
                        <div className="form-group"><label>Date of Retirement</label><WidgetDatePicker value={date_of_retirement} setDate={setDateOfRetirement} placeholder="Select Date" />{errors.date_of_retirement && <ErrorMessage messages={errors.date_of_retirement} />}</div>
                      </CCol>
                    </>
                  )}

                  {/* <CCol md={4}>
                    <div className="form-group">
                      <label>Are you a reservist in the armed forces?</label>
                      <WidgetSelector
                        options={ArmedForceOptions}
                        placeHolder={'Please Select'}
                        selectedValue={armed_force}
                        onChange={(values) => setArmedForce(values.value)}
                      />
                      {errors.armed_force && <ErrorMessage messages={errors.armed_force} />}
                    </div>
                  </CCol>
                  <CCol md={4}>
                    <div className="form-group">
                      <label>Are you affiliated with any political party?</label>
                      <WidgetSelector
                        options={PoliticalPartyOptions}
                        placeHolder={'Please Select'}
                        selectedValue={political_party}
                        onChange={(values) => setPoliticalParty(values.value)}
                      />
                      {errors.political_party && <ErrorMessage messages={errors.political_party} />}
                    </div>
                  </CCol>
                  <CCol md={6}>
                    <div className="form-group" style={{ marginBottom: '20px' }}>
                      <label>Are you under any service bond with your present employer?</label>
                      <WidgetSelector
                        options={ServiceBondOptions}
                        placeHolder={'Please Select'}
                        selectedValue={service_bond}
                        onChange={(values) => setServiceBond(values.value)}
                      />
                      {errors.service_bond && <ErrorMessage messages={errors.service_bond} />}
                    </div>
                  </CCol>

                  <CCol md={6}>
                    <div className="form-group" style={{ marginBottom: '20px' }}>
                      <label>
                        Have you suffered from any illness disability during last 5 years?
                      </label>
                      <WidgetSelector
                        options={DisabilityOptions}
                        placeHolder={'Please Select'}
                        selectedValue={disability}
                        onChange={(values) => setDisability(values.value)}
                      />
                      {errors.disability && <ErrorMessage messages={errors.disability} />}
                    </div>
                  </CCol>

                  <CCol md={6}>
                    <div className="form-group" style={{ marginBottom: '20px' }}>
                      <label>Have you ever been convicted for any criminal charge?</label>
                      <WidgetSelector
                        options={CriminalChargeOptions}
                        placeHolder={'Please Select'}
                        selectedValue={criminal_charge}
                        onChange={(values) => setCriminalCharge(values.value)}
                      />
                      {errors.criminal_charge && <ErrorMessage messages={errors.criminal_charge} />}
                    </div>
                  </CCol> */}
                </CRow>
              </CForm>
              <br />
              <CButton color="primary" onClick={() => save()} disabled={isDisabled}>
                Submit
              </CButton>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </>
  )
}
